"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberOfAxelsOptions = void 0;
exports.numberOfAxelsOptions = [
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5+', value: '5' },
];
